import authenticatedRequest from '../authenticatedRequest';
import invariant from 'invariant';
import labelRequest from '../labelRequest';

export default function putUserSubscriptions(params) {
    const { baseUrl, brandId, country, accessKey, email, uberToken, clientId, subscriptions } = params;

    invariant(baseUrl, 'baseUrl is a required param of putUserSubscriptions()');
    invariant(brandId, 'brandId is a required param of putUserSubscriptions()');
    invariant(country, 'country is a required param of putUserSubscriptions()');
    invariant(subscriptions, 'subscriptions is a required param of putUserSubscriptions()');

    const headers = { 'Content-Type': 'application/json' };
    const url = `${baseUrl}wcs/resources/store/${brandId}_${country.toLowerCase()}/usersubscriptions/@self`;
    const jsonBody = JSON.stringify(subscriptions);
    const options = { headers: new Headers(headers), method: 'PUT', body: jsonBody };

    if (accessKey && email) {
        return labelRequest(
            authenticatedRequest(new Request(`${url}?accessKey=${accessKey}&email=${email}`, options), undefined, clientId),
            'putUserSubscriptions',
        );
    }
    return labelRequest(authenticatedRequest(new Request(url, options), uberToken, clientId), 'putUserSubscriptions');
}
